// AUTO-GENERATED — do not edit. Source: /shared/. Run scripts/sync-shared.sh to update.
/**
 * SLIK — Canonical Barber Visibility (BRAIN #4, 2026-08-03)
 * ========================================================
 * ONE rule for "should this barber be shown / bookable?" so the POS, customer-portal and
 * public-booking can't disagree. Pure logic — no React, no Firebase.
 *
 * Background: the POS archive/status work (status: active|inactive|deleted|on-leave) never
 * reached the portals. The portals read `collection(db,'barbers')` RAW with no/partial filter,
 * so an inactive barber ("James") leaked into customer booking. Two status models also drifted:
 * POS uses a `status` STRING, the portal uses an `isActive` BOOLEAN. This helper honors BOTH.
 *
 * DO NOT edit the per-app copies in <app>/src/shared/ — edit THIS file and run scripts/sync-shared.sh.
 */

export interface StatusBarber {
  status?: string;         // POS: 'active' | 'inactive' | 'deleted' | 'on-leave' | 'archived' | ...
  isActive?: boolean;      // portal legacy boolean
  careerStage?: string;    // 'Apprentice' should not be customer-bookable
}

/** Statuses that mean "not visible / not bookable". */
const HIDDEN_STATUSES = new Set([
  'inactive', 'deleted', 'archived', 'on-leave', 'onleave', 'terminated', 'suspended',
]);

export interface BarberVisibilityOpts {
  /** Hide apprentices (default true — apprentices aren't customer-bookable). */
  hideApprentice?: boolean;
}

/**
 * Is this barber visible / bookable? Tolerant of both status models.
 * Missing `status` and `isActive` → treated as visible (don't hide legit barbers with no field).
 */
export function isBookableBarber(barber: StatusBarber | null | undefined, opts: BarberVisibilityOpts = {}): boolean {
  if (!barber) return false;
  const hideApprentice = opts.hideApprentice !== false;
  if (barber.status != null && HIDDEN_STATUSES.has(String(barber.status).toLowerCase())) return false;
  if (barber.isActive === false) return false;
  if (hideApprentice && barber.careerStage === 'Apprentice') return false;
  return true;
}

/** Filter a list to only visible/bookable barbers. */
export function visibleBarbers<T extends StatusBarber>(list: T[], opts: BarberVisibilityOpts = {}): T[] {
  return (list || []).filter(b => isBookableBarber(b, opts));
}
